import { ReactNode } from 'react';
import './Tabs.css';

type TabsProps = { children: ReactNode };
export const Tabs = ({ children }: TabsProps) => {
	return <ul className="tabs">{children}</ul>;
};
